import React from 'react'
import Sidebar from '../../../Components/Sidebar/Sidebar';
import { salesSideBarItems } from './Routes'

const Navbar = () => {
    return <Sidebar sideBarItems={salesSideBarItems} />
}

export default Navbar;